// extracted by mini-css-extract-plugin
export var hideEditor = "_mu-2";
export var infoIcon = "_mu-3";
export var label = "_mu-1";
export var labelContainer = "_mu-0";
export var readonlyText = "_mu-4";